import './App.css';
import TodoTask from './Todo/screen/todo-task';

function App() {
  return (
    <div className="App">
      <TodoTask />
    </div>
  );
}

export default App;
